import DisplayMenu from "./DisplayMenu.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import { useUser } from "../../../contexts/userContext/userContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import config from "config.ts";

const avatarImage = `${config.api.resource}/assets/images/avatar_default_large.png`;

const ProfileMenu = () => {
  const { getUserData, getUserProfileImage, isUserHasProfileImage } = useUser();
  const { getTextByKey } = useContent();

  return (
    <>
      <div className="profile-menu-sticky">
        <div className="profile-image">
          <div className="grey-border-profile">
            <div className="user-avatar-image-container">
              <Image
                className={`user-avatar-image ${
                  !isUserHasProfileImage() ? " default-avatar" : ""
                }`}
                src={
                  isUserHasProfileImage() ? getUserProfileImage() : avatarImage
                }
                title=""
                alt=""
              />
              <div className="edit-profile-picture-div">
                <LinkToNewTab page={"user/profile/details"}>
                  <span>
                    <Icon name="pencil-alt-solid" />
                  </span>
                </LinkToNewTab>
              </div>
            </div>
          </div>
        </div>
        <div className="menu-title">
          <h3>{getTextByKey("profile-menu-title")}</h3>
        </div>
        <div>
          <DisplayMenu userData={getUserData()} />
        </div>
      </div>
    </>
  );
};

export default ProfileMenu;
